export default "__VITE_ASSET__DrBg1QIQ__"